import { getService } from 'react-in-angularjs';
import { goTo } from '../../../../../../utils/angularUtils';
import { EntityTypeFlags } from '../../../../../../constants/user-info/ENTITY_TYPES';

export const backToChildEntityList = (entityType: EntityTypeFlags) => {
  if (entityType.SCHOOL) {
    const AuthService = getService('AuthService');

    AuthService.childToParentLogin();
  } else {
    goTo('/child-entity-list', { replaceHistory: true });
  }
};
